import { Footer } from "@/components/footer";
import Header from "@/components/header";
import { useMonitoredOfferCounts } from "@/hooks/use-monitored-offer-counts";
import { StoresContent } from "./stores-content";
function StoresPage() {
  const counts = useMonitoredOfferCounts();
  return <div className="flex min-h-screen flex-col">
      <Header showSearch={false} />
      <StoresContent monitoredOfferCount={counts?.all ?? null} />
      <Footer />
    </div>;
}
export { StoresPage as component };